<template>
  <input
    class="h-10 border rounded-full focus:outline-none px-5"
    :class="[`border-${color}`, block ? 'w-full' : '']"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'AppTextInput',

  props: {
    color: String,
    modelValue: [Number, String],
    // full width (block)
    block: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
